/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as l from "react";
function c(e) {
  const t = e.onClick ? {
    onClick: e.onClick
  } : {}, n = /* @__PURE__ */ l.createElement("span", { className: "k-link", ...t }, /* @__PURE__ */ l.createElement("span", { className: "k-column-title" }, e.title || e.field || " "), e.children);
  return /* @__PURE__ */ l.createElement(l.Fragment, null, e.render ? e.render.call(void 0, n, e) : n);
}
export {
  c as HeaderCell
};
